import { render, staticRenderFns } from "./LoginOpen.vue?vue&type=template&id=2c0641df"
import script from "./LoginOpen.vue?vue&type=script&lang=js"
export * from "./LoginOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports